import React, { Component } from 'react';
import classes from './Skills.module.css';

import HorizontalBar from '../HorizontalBar/HorizontalBar';

import Card from '../Card/Card';

class Skills extends Component {
  state = {
    skills: ['Javascript', 'React', 'Redux', 'Node', 'Express', 'MongoDB']
  };

  render() {
    const { skills } = this.state;
    const skillSet = skills.map((skill, index) => (
      <div className={classes.Skills} key={skill}>
        {index === 0 ? null : <HorizontalBar />}
        {skill}
      </div>
    ));
    return (
      <Card eventTypes="click" goBack={this.props.history.goBack}>
        <h1>Skills</h1>
        {skillSet}
      </Card>
    );
  }
}

export default Skills;
